import { render, staticRenderFns } from "./ModalProcess.vue?vue&type=template&id=5b7728c5&scoped=true"
import script from "./ModalProcess.vue?vue&type=script&lang=js"
export * from "./ModalProcess.vue?vue&type=script&lang=js"
import style0 from "./ModalProcess.vue?vue&type=style&index=0&id=5b7728c5&prod&scoped=true&lang=css"
import style1 from "./ModalProcess.vue?vue&type=style&index=1&id=5b7728c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7728c5",
  null
  
)

export default component.exports